import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 设备鉴权
 */
const proximityCard = {

  /**
   * 创建
   */
  createProximityCard (companyId, number, name, kind) {
    return axios.post(base.proximityCard.createProximityCard, utils.postParamsArrayToJsonString({ companyId, number, name, kind }))
  },
  /**
   * 修改
   */
  modifyProximityCard (id, name, kind) {
    return axios.post(base.proximityCard.modifyProximityCard, utils.postParamsArrayToJsonString({ id, name, kind }))
  },
  /**
   * 删除
   */
  deleteProximityCard (id) {
    return axios.post(base.proximityCard.deleteProximityCard, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getProximityCards (companyId) {
    return axios.post(base.proximityCard.getProximityCards, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 添加
   */
  addProximityCardHoldingRecord (cardId, userId, startTime, endTime) {
    return axios.post(base.proximityCard.addProximityCardHoldingRecord, utils.postParamsArrayToJsonString({ cardId, userId, startTime, endTime }))
  },
  /**
   * 修改
   */
  modifyProximityCardHoldingRecord (id, startTime, endTime) {
    return axios.post(base.proximityCard.modifyProximityCardHoldingRecord, utils.postParamsArrayToJsonString({ id, startTime, endTime }))
  },
  /**
   * 删除
   */
  deleteProximityCardHoldingRecord (id) {
    return axios.post(base.proximityCard.deleteProximityCardHoldingRecord, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getProximityCardHoldingRecords (companyId, cardsId, startTime, endTime) {
    return axios.post(base.proximityCard.getProximityCardHoldingRecords, utils.postParamsArrayToJsonString({ companyId, cardsId, startTime, endTime }))
  },
  /**
   * 查询
   */
  getProximityCardHoldingRecords2 (companyId, usersId, startTime, endTime) {
    return axios.post(base.proximityCard.getProximityCardHoldingRecords2, utils.postParamsArrayToJsonString({ companyId, usersId, startTime, endTime }))
  },
}

export default proximityCard